import api from "../services/api";

class Model {
    statists = () => {
        return api.get("/inpatics/statist");
    }
}

const model = new Model();
export default model;